import { namespaceActions } from 'modules/app-core/redux-utils'
import { NAME } from './constants'

const USER_INITIALIZED = 'USER_INITIALIZED'
const SET_CURRENT_COMPANY = 'SET_CURRENT_COMPANY'
const SET_QLE = 'SET_QLE'
const SET_CURRENT_URL = 'SET_CURRENT_URL'
const CLEAR_CURRENT_URL = 'CLEAR_CURRENT_URL'

export default namespaceActions(NAME)([
  USER_INITIALIZED,
  SET_CURRENT_COMPANY,
  SET_QLE,
  SET_CURRENT_URL,
  CLEAR_CURRENT_URL,
])
